import { useEffect, useState } from "react";
import "./App.css";
import values from "values.js";
import Single from "./SingleColor";

export default function App() {
	const [color, setColor] = useState("");
	const [error, setError] = useState(false);
	const [colorList, setColorList] = useState([]);

	const handlesubmit = (e) => {
		e.preventDefault();

		try {
			let colors = new values(color).all(10);
			setColorList(colors);
			setColor("")
		} catch (error) {
			setError(true);
			console.log(error);
		}
	};

	useEffect(() => {
		setTimeout(() => {
			setError(false);
		}, 3000);
	}, [error]);

	const saurabhTwiiter = "https://twitter.com/DaswantSaurabh";

	return (
		<>
			<main className="px-10 md:max-w-5xl m-auto mt-10">
				<div>
					<div className="">
						<h1 className=" heading rounded py-5 flex text-center items-center justify-center text-3xl md:text-5xl font-black bg-gradient-to-r from-purple-400 ">The Tint &amp; Shade generator</h1>
					</div>
					<form onSubmit={handlesubmit} className=" flex flex-col md:w-9/12 m-auto" >
						<p className="text-2xl text-center mt-5" >Enter hex Values or color name 👇🏼</p>
						<input
							type="text"
							value={color}
							onChange={(e) => setColor(e.target.value)}
							className={` h-32 md:h-52 mt-5 bg-gray-100 rounded outline-none mb-5 ${error ? " border-4 border-red-500" : null}`}
						/>
						<button className="bg-gray-800 active:bg-gray-900 capitalize text-xl text-gray-50 py-5 rounded" type="submit">generate tints and shades 🌈</button>
					</form>
				</div>
				<div className=" mt-20 grid grid-cols-2 sm:grid-cols-4   xl:grid-cols-5 gap-5" >
					{colorList.map((color, index) => {
						const { hex } = color;
						return <Single key={index} {...color} index={index} hex={hex} />;
					})}
				</div>

			</main>
			<footer className=" flex flex-wrap  justify-center items-center relative bottom-0 max-w-full  text-center md:h-10  bg-blue-50 mt-24 ">
				Made with <a className=" mx-1 text-blue-900" href="https://reactjs.org/" rel="noreferrer" target="_blank">React.js</a> and
				<a href="https://tailwindcss.com/" className="mx-1 text-blue-900" rel="noreferrer" target="_blank">tailwind css</a> |
				connect with me on<a className="text-blue-900 mx-1" href={saurabhTwiiter} rel="noreferrer" target="_blank"> twiiter</a> |
				UI inspiration : <a href="https://maketintsandshades.com/" className="mx-1 text-blue-900" rel="noreferrer" target="_blank">Michael Edelstone
				</a>
			</footer>
		</>
	);
}
